module.exports = __webpack_public_path__ + "media/images/flags/16/Samoa-bb1986c7bd2beb9887269958ca2eb848.png";